<template>
    <div class="personal-profile-section" :class="{ 'blocked' : editMode }" >
        <span class="personal-profile-section-title"> Подписка </span>
        <p class="mb-3">Будьте в курсе новых поступлений, акций и распродаж. Рассылка происходит раз в месяц.</p>

        <div class="q-gutter-sm ml-auto">
            <q-btn color="primary" @click="save" label="Сохранить"></q-btn>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex';
    import { Form } from '../../classes/Form';

    export default {
        name: 'CustomerSubscription',
        props: {
            customer: {
                type: Object,
                required: true
            },
        },
        data () {
            return {
                form: {}
            };
        },
        mounted () {
            let _this = this;

            _this.form = new Form({
                email_subscription: !!_this.customer.email_subscription,
                sms_subscription: !!_this.customer.sms_subscription,
            });
        },
        methods: {
            ...mapMutations('customer', [
                'editSection',
            ]),

            save () {
                let _this = this;

                _this.form.put('/account/subscription');
            }
        },
        computed: {
            ...mapGetters('customer', {
                editMode: 'editMode',
            })
        },
    }
</script>
